import {
  EffectCallback,
  DependencyList,
  useLayoutEffect,
  useState,
  useEffect,
  useMemo,
} from 'react';

// lib/canUseDOM
const canUseDOM = (): boolean => {
  return (
    typeof window !== 'undefined' &&
    typeof window.document !== 'undefined' &&
    typeof window.document.createElement !== 'undefined'
  );
};

// lib/useIsomorphicLayoutEffect
const useIsomorphicLayoutEffect = (
  fn: EffectCallback,
  deps: DependencyList
): void => {
  return canUseDOM() ? useLayoutEffect(fn, deps) : useEffect(fn, deps);
};

let isClientEnv = false;
let id = 0;

const generateId = (prefix: string) => {
  return `${prefix}${++id}`;
};

export const useUniqId = (prefix: string = '_'): string | undefined => {
  const idRef = useMemo(
    () => (isClientEnv ? generateId(prefix) : undefined),
    []
  );
  const [id, setId] = useState(idRef);

  useIsomorphicLayoutEffect(() => {
    if (id === undefined) {
      setId(generateId(prefix));
    }
  }, []);

  useEffect(() => {
    if (!isClientEnv) {
      isClientEnv = true;
    }
  }, []);

  return id;
};

// export type declarations for useUniqId
export type useUniqId = {
  label: string;
  size: number;
};
